import styles from "../../styles/LoadingAnimation.module.scss";

export default function LoadingAnimation() {
  return (
    <div className={styles.main}>
      <div className={styles.lds_ring}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p>Loading please wait...</p>
    </div>
  );
}
